import { Prop, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import Component, { mixins } from 'vue-class-component'
import submitProtectionMixin from '@/modules/common/mixins/submitProtectionMixin'
import confirmMixin from '@/modules/common/mixins/confirmMixin'
import notificationService from '@/modules/common/services/notificationService'
import EntityCreateParams from '@/modules/common/store/entityCreateParams'
import EntityDeleteParams from '@/modules/common/store/entityDeleteParams'

@Component
export default class CreateModal extends mixins(submitProtectionMixin, confirmMixin) {
  item: any | null = null
  moduleName?: string
  doFetchAfterDefault = true
  doFetchAfterDelete = true
  show = false
  modelInitialized = false
  deleteConfirmation = 'entity.delete.confirmation'

  @Prop(Object) model!: any
  @Prop({ type: Boolean, default: false }) showModal!: boolean
  @Prop({ type: Boolean, default: true }) doFetchAfter!: boolean

  onSubmit () {
    this.beforeSave()

    if (!this.validate()) {
      return this.unprotect()
    }

    let operation = this.moduleName || ''
    if (this.isEdit()) {
      operation += '/update'
    } else {
      operation += '/create'
    }

    this.$store.dispatch(operation, new EntityCreateParams(this.item, this.doFetchAfter && this.doFetchAfterDefault)).then((item) => {
      notificationService.success('entity.edit.success')
      this.afterSuccessSave(item)
      this.onClose()
    }).catch(reason => notificationService.error(reason.message)).finally(this.unprotect)
  }

  beforeSave () {
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  afterSuccessSave (item: any) {
  }

  afterSuccessDelete () {
  }

  validate () {
    return true
  }

  beforeClose () {
  }

  afterModelSet () {
  }

  isEdit () {
    return !!this.item && !_.isNil(this.item.id)
  }

  onClose () {
    this.beforeClose()
    this.$emit('close')
  }

  @Watch('model')
  onModelChange (newValue: any) {
    this.modelInitialized = false
    this.item = _.cloneDeep(newValue)
    // mark that model is initialized
    this.$nextTick(() => {
      this.afterModelSet()
      this.modelInitialized = true
    })
  }

  @Watch('showModal')
  onShowModalChange (showModal: boolean) {
    this.show = showModal
  }

  deleteItem () {
    this.confirm(this.deleteConfirmation).then((value) => {
      if (value) {
        this.$store.dispatch(this.moduleName + '/delete', new EntityDeleteParams(this.item!, this.doFetchAfterDelete)).then((result) => {
          if (result) {
            this.$emit('close')
            notificationService.success('entity.delete.success')
            this.afterSuccessDelete()
          }
        }).finally(this.unprotect)
      }
    })
  }
}
